import { RankForm } from "./RankForm";

const AddRank = () => {
  return <RankForm edit={false} />;
};

export { AddRank };
